import { InteractionType, EventSource, MixpanelEvent, ComponentType } from '../MixPanelTypes';

export type TimesheetHubEvents = 'EXPORT_RESULT' | 'REJECT_TIMESHEET_CLICK' | 'APPROVE_TIMESHEET_CLICK';

export const timesheetHub: Record<TimesheetHubEvents, MixpanelEvent> = {
  EXPORT_RESULT: {
    eventDescription: 'Export Timesheet Result',
    eventKey: 'export-timesheet-result ',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  APPROVE_TIMESHEET_CLICK: {
    eventDescription: 'Approve Timesheet Click',
    eventKey: 'approve-timesheet-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DRAWER_PRIMARY_ACTION_BUTTON
  },
  REJECT_TIMESHEET_CLICK: {
    eventDescription: 'Reject Timesheet Click',
    eventKey: 'reject-timesheet-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DRAWER_SECONDARY_ACTION_BUTTON
  }
};

export type ActionEventSource =
  | 'Side Panel'
  | 'Table Row Overflow Menu'
  | 'Rejection Note Dialog'
  | 'Table Bulk Action';

export type TimeSheetEventOrigin = {
  source: ActionEventSource;
};
